const DATA_SAVED = "extragestor/ventasCitas/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/ventasCitas/RESET_DATA_SAVED";

const ADDED_CITA_DE_VENTA = "extragestor/ventasCitas/ADDED_CITA_DE_VENTA";
const REMOVED_CITA_DE_VENTA = "extragestor/ventasCitas/REMOVED_CITA_DE_VENTA";
const CHANGED_CITA_DE_VENTA = "extragestor/ventasCitas/CHANGED_CITA_DE_VENTA";

const LIMPIAR_CITAS_DE_VENTA = "extragestor/ventasCitas/LIMPIAR_CITAS_DE_VENTA";

/*---------------------------------------------------------------------------*/

export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  ADDED_CITA_DE_VENTA,
  REMOVED_CITA_DE_VENTA,
  CHANGED_CITA_DE_VENTA,
  LIMPIAR_CITAS_DE_VENTA
};



// WEBPACK FOOTER //
// ./src/ducks/ventasCitas/types.js